const t=e=>({value:e.toFixed(1)});export{t as useStar};
